var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3614 10.8194C25.3614 15.0022 25.6364 18.7391 22.6124 21.2061C20.2654 23.1218 15.7901 23.9149 12.5116 23.9149C5.00925 23.9149 0.395996 18.2488 0.395996 10.8194C2.23169 3.94041 6.16908 0.730225 13.6714 0.730225C16.9499 0.730225 18.7339 0.954616 21.0809 2.87034C24.1049 5.33728 25.3614 6.63664 25.3614 10.8194Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3614 10.8194C25.3614 15.0022 25.6364 18.7391 22.6124 21.2061C20.2654 23.1218 15.7901 23.9149 12.5116 23.9149C5.00925 23.9149 0.395996 18.2488 0.395996 10.8194C2.23169 3.94041 6.16908 0.730225 13.6714 0.730225C16.9499 0.730225 18.7339 0.954616 21.0809 2.87034C24.1049 5.33728 25.3614 6.63664 25.3614 10.8194Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1953 0H12.5005C5.59613 0 0 5.43676 0 12.1446C0 18.8513 5.59613 24.2891 12.5004 24.2891H16.1952C23.0996 24.2891 28.6957 18.8513 28.6957 12.1446C28.6957 5.43676 23.0996 0 16.1953 0ZM12.5004 23.1282C6.257 23.1282 1.19496 18.2102 1.19496 12.1446C1.19496 6.07893 6.25706 1.16094 12.5004 1.16094C18.7438 1.16094 23.806 6.07887 23.806 12.1446C23.806 18.2103 18.7439 23.1282 12.5004 23.1282Z",
    fill: "#0059C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89179 5.72388C7.2588 6.73419 5.39502 9.22681 5.39502 12.144C5.39502 15.0613 7.2588 17.5539 9.89179 18.5642V5.72388Z",
    fill: "#0059C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1076 5.72388V18.5642C17.7407 17.5539 19.6044 15.0613 19.6044 12.144C19.6044 9.22681 17.7407 6.73413 15.1076 5.72388Z",
    fill: "#0059C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/diners-club.5f206f3b421a6b0ae7e9db237f3d0ea0.svg";
export { ForwardRef as ReactComponent };